import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNoDataAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.data) {
    return next();
  } else {
    return next({ name: 'home' });
  }
};
